import MarketingSplitSection from "@/components/marketing/MarketingSplitSection";
import WeeklyRecheckMock from "@/components/marketing/WeeklyRecheckMock";

export default function WeeklyRecheckSection() {
  return (
    <MarketingSplitSection
      id="weekly-recheck"
      tone="slate"
      flip
      title="Recheck every week"
      description="We recheck monitored pages and journeys and show what’s new, fixed, and still open. Each recheck uses one audit from your plan budget."
    >
      <WeeklyRecheckMock />
    </MarketingSplitSection>
  );
}
